import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Tree } from 'antd';
import { isEmpty } from 'lodash';
import './PagesTree.css';

const Component = props => {
    const { pages, activePage, onNodeSelected } = props;
    const [treeData, setTreeData] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState(['/']);
    const [expandedKeys, setExpandedKeys] = useState(['/']);

    /** When: active page changed **/
    useEffect(() => {
        if (activePage) {
            setSelectedKeys([activePage.path]);
            setExpandedKeys(createExpandedKeysArr(activePage.path));
        } else {
            setSelectedKeys(['/']);
            setExpandedKeys(['/']);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activePage, setSelectedKeys, setExpandedKeys]);

    /** When: pages changed **/
    useEffect(() => {
        setTreeData([
            {
                title: 'Root',
                value: '/',
                key: '/',
                selectable: selectedKeys[0] !== '/',
                children: pages
                          .sort( (a, b) => (a.order !== undefined ? a.order : Number.MAX_VALUE) - (b.order !== undefined? b.order : Number.MAX_VALUE))
                          .map(convertPageToTreeData)
            }
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pages, setTreeData, selectedKeys]);

    /* ~~~~ Event-handlers ~~~~ */
    const handleExpandClicked = expandedKeys => {
        setExpandedKeys(expandedKeys);
    };
    const handleTreeNodeSelected = selectedKeys => {
        onNodeSelected && onNodeSelected(selectedKeys[0]);
    };

    /* ~~~~ Util-methods ~~~~ */
    const createExpandedKeysArr = path => {
        let expandedKeys = [];
        const pathArr = path.split('/').filter(part => part !== '');

        pathArr.forEach(pathPart => {
            let lastKey = expandedKeys[expandedKeys.length - 1];
            let newKey = (lastKey ? lastKey : '') + '/' + pathPart;
            expandedKeys.push(newKey);
        });

        expandedKeys.push('/');

        return expandedKeys;
    };
    const convertPageToTreeData = page => {
        let treeData = { title: page.title, value: page.path, key: page.path, selectable: selectedKeys[0] !== page.path, children: [], order: page.order};
        if (!isEmpty(page.subpages)) {
            for (let subpage in page.subpages) {
                treeData.children.push(convertPageToTreeData(page.subpages[subpage]));
            }
            treeData.children.sort( (a, b) => (a.order !== undefined ? a.order : Number.MAX_VALUE) - (b.order !== undefined? b.order : Number.MAX_VALUE));
        } else {
            treeData.selectable = false;
        }
        return treeData;
    };

    return <Tree className="pagesTree" treeData={treeData} selectedKeys={selectedKeys} expandedKeys={expandedKeys} onExpand={handleExpandClicked} onSelect={handleTreeNodeSelected} />;
};

const mapComponentStateToProps = state => ({
    pages: state.pages.pages
});

const PagesTree = connect(
    mapComponentStateToProps,
    null
)(Component);

export default PagesTree;
